import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox-list',
  standalone: false,
  templateUrl: './checkbox-list.component.html',
  styleUrl: './checkbox-list.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxListComponent,
      multi: true
    }
  ]
})
export class CheckboxListComponent implements ControlValueAccessor {
  @Input() options: { value: string | number; label: string; }[] = [];
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() title: string = '';

  selectedValues: (string | number)[] = [];

  onChange = (_: (string | number)[]) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.selectedValues = Array.isArray(value) ? value : [];
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  toggleValue(val: string | number, checked: boolean) {
    const updated = checked
      ? [...this.selectedValues, val]
      : this.selectedValues.filter(v => v !== val);

    this.selectedValues = updated;
    this.onChange(updated);
    this.onTouched();
  }

  onCheckboxChange(event: Event, value: string | number) {
    const input = event.target as HTMLInputElement;
    const checked = input.checked;
    this.toggleValue(value, checked);
  }

}
